/**
 * Labstep
 *
 * @module screens/Landing/Login/ContinueButton
 * @desc Continue Button for login modal
 */

import { Button } from 'labstep-web/core/Button';
import type { IButtonProps } from 'labstep-web/core/Button/types';
import type React from 'react';

export const ContinueButton: React.FC<IButtonProps> = ({
  children,
  ...rest
}) => (
  <Button {...rest} type="submit" fluid primary loader>
    {children}
  </Button>
);
